
<ngx-spinner
  bdColor="rgba(0, 0, 0, 0.5)"
  [fullScreen]="true"
>
  <div class="custom-spinner">
    <img
      src="assets/icons/spinner-otic-2018.png"
      alt="Logo Empresa"
      class="spinner-logo"
    />
  </div>
</ngx-spinner>
<router-outlet></router-outlet>
@if (isNewAppVersionAvailable) {
  <app-update-worker (update)="refreshApp()"/>
}
